/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface V1PodSchedulingGate
 */
export interface V1PodSchedulingGate {
    /**
     * Name of the scheduling gate.
     * Each scheduling gate must have a unique name field.
     * @type {string}
     * @memberof V1PodSchedulingGate
     */
    name?: string;
}

export function V1PodSchedulingGateFromJSON(json: any): V1PodSchedulingGate {
    return V1PodSchedulingGateFromJSONTyped(json, false);
}

export function V1PodSchedulingGateFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1PodSchedulingGate {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function V1PodSchedulingGateToJSON(value?: V1PodSchedulingGate | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}

